export const WMS_APP_SESSION_KEY = 'wms:installed-app';
export const WMS_APP_START_PATH = '/wms/';
export const WMS_APP_MANIFEST = '/wms/manifest.json';
export const WMS_APP_DISPLAY_QUERY = '(display-mode: standalone), (display-mode: fullscreen)';

export function isWmsPath(pathname: string): boolean {
  return pathname === '/wms' || pathname.startsWith('/wms/');
}

export function isWmsAppRouteAllowed(pathname: string): boolean {
  return isWmsPath(pathname)
    || ['/login', '/forgot-password', '/reset-password', '/check-email'].includes(pathname);
}

export function isWmsAppDisplay(): boolean {
  if (typeof window === 'undefined') return false;
  if ((window.navigator as Navigator & { standalone?: boolean }).standalone === true) return true;
  // Element fullscreen also matches display-mode: fullscreen in an ordinary tab.
  // Manifest fullscreen is independent of the Fullscreen API and has no element.
  return window.matchMedia?.(WMS_APP_DISPLAY_QUERY).matches === true
    && (typeof document === 'undefined' || !document.fullscreenElement);
}

export function shouldUseWmsApp(url: URL, inAppWindow: boolean, remembered: boolean): boolean {
  if (url.searchParams.get('app') === 'wms'
    || (inAppWindow && (isWmsPath(url.pathname) || remembered))) return true;
  // An expired login can redirect before the app runtime has mounted.
  const returnPath = url.pathname === '/login' ? url.searchParams.get('redirect') : null;
  if (!returnPath?.startsWith('/') || returnPath.startsWith('//')) return false;
  try {
    const returnUrl = new URL(returnPath, url.origin);
    return returnUrl.origin === url.origin && isWmsPath(returnUrl.pathname)
      && (inAppWindow || returnUrl.searchParams.get('app') === 'wms');
  } catch { return false; }
}

export interface WmsInstallPrompt extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}
